import React from "react";

const SvgBBiconsBmAnalyzaOdvetvi = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <style>
      {".BBicons_BM-Analyza_odvetvi_svg__st4{display:none;fill:#6afff8}"}
    </style>
    <g id="BBicons_BM-Analyza_odvetvi_svg__Bo\u010Dn\xED_menu">
      <circle
        className="BBicons_BM-Analyza_odvetvi_svg__st4"
        cx={-122.8}
        cy={100}
        r={126.4}
      />
      <circle
        className="BBicons_BM-Analyza_odvetvi_svg__st4"
        cx={317.2}
        cy={100}
        r={126.4}
      />
      <circle
        className="BBicons_BM-Analyza_odvetvi_svg__st4"
        cx={-120}
        cy={100}
        r={126.4}
      />
      <circle
        className="BBicons_BM-Analyza_odvetvi_svg__st4"
        cx={100}
        cy={100}
        r={126.4}
      />
      <path
        d="M162.8 74.4c1.8 4.5 3.2 9.1 4 13.7h-7.2c-.8-3.7-1.9-7.4-3.3-11.1-8.6-21-27.3-35.6-49.1-39.6-.1 7.7-.9 64.1-.9 64.6v.9c0 .2 0 .3-.1.5 0 .1 0 .2-.1.5-.1.6-.3 1.1-.4 1.6-.1.4-.3.7-.5 1.2l-.9 1.5s-.1.1-.1.2c-.3.4-.5.6-.8 1-.6.6-1.3 1.2-2.1 1.7-.3.2-.5.3-.8.4h-.1c-.6.3-1.2.5-1.8.6-.1 0-.2.1-.3.2-.3.1-.5.2-.8.2-.1 0-56.1 10.4-63.6 11.8.3.8.5 1.6.8 2.3 10.2 25.1 34.1 40.4 59.5 40.9-.8 1.3-1.3 2.9-1.3 4.5 0 .8.1 1.7.4 2.4-27.8-.9-53.9-17.8-65.1-45.3-.9-2.1-1.6-4.3-2.3-6.6-.6-2 .7-4.1 2.7-4.5.6-.1 66.8-12.4 67.4-12.5.1 0 .2-.1.4-.1l.9-.3c.1 0 .2-.1.3-.1.3-.2.5-.4.7-.6l.1-.1s.1-.2.2-.3c.1-.2.2-.3.3-.5.1-.2.1-.3.2-.4 0-.1.1-.3.1-.6 0-.2 0-.3.1-.4v-.2-.2c0-.5 1-68.2 1-68.8 0-2.1 1.9-3.7 3.9-3.5 26 3.4 48.5 20.3 58.6 45zM89.7 89.2c1-.7 1.7-1.8 1.7-3.1l.1-6.1.7-49.8v-.9c0-1-.4-2-1.1-2.7-.7-.7-1.7-1.1-2.7-1.1-8 .2-15.7 1.7-23 4.7-8.1 3.3-15.3 8.1-21.4 14.2-5.1 5.1-9.3 11.1-12.5 17.8-.4.9-.5 2-.1 3s1.1 1.7 2.1 2.1l52.7 22.3c.5.2 1 .3 1.5.3.6-.1 1.4-.3 2-.7zM49.3 49.7c5.4-5.4 11.7-9.6 18.9-12.5 5.2-2.1 10.8-3.5 16.4-3.9L84 75.7v4.8L40.1 61.9c2.5-4.5 5.6-8.6 9.2-12.2zm-26.9 61.2l5.5-1c.1 0 .3-.1.4-.1l48.6-9 .5-.1c1.6-.3 2.8-1.7 3-3.3.2-1.6-.8-3.2-2.3-3.8L27.3 72.1c-.9-.4-2-.4-3 0-.9.4-1.7 1.2-2 2.1-1.4 3.8-2.4 7.2-3.1 10.4-1 4.7-1.5 9.6-1.6 14.5 0 2.5.1 5.2.4 8.4.1 1 .6 2 1.5 2.6.7.5 1.4.7 2.2.7.3.2.5.1.7.1zm41.3-15.3l-37.1 6.9c-.1 0-.3.1-.4.1l-1 .2c-.1-1.2-.1-2.3-.1-3.4.1-4.4.6-8.8 1.5-13.1.4-1.8.9-3.7 1.5-5.7l35.6 15zm75.8-.2c-1.4 0-2.6 1.2-2.6 2.6v72.1h-2v-47.5c0-1.4-1.2-2.6-2.6-2.6h-23.8c-1.4 0-2.6 1.2-2.6 2.6v47.5h-4c-1.1 0-2.1.9-2.1 2.1 0 1.1.9 2.1 2.1 2.1h78.5c1.1 0 2.1-.9 2.1-2.1 0-1.1-.9-2.1-2.1-2.1h-4.2V98c0-1.4-1.2-2.6-2.6-2.6h-34.1zm31.5 74.7h-7.2v-14.6c0-.7-.6-1.3-1.3-1.3h-12c-.7 0-1.2.6-1.2 1.3v14.6h-7.2v-69.6H171v69.6zm-25.6-61.6c-.9 0-1.6.9-1.6 2s.7 2 1.6 2h22.2c.9 0 1.6-.9 1.6-2s-.7-2-1.6-2h-22.2zm0 13.9c-.9 0-1.6.9-1.6 2s.7 2 1.6 2h22.2c.9 0 1.6-.9 1.6-2s-.7-2-1.6-2h-22.2zm-15.7 47.7h-18.6v-44.9h18.6v44.9zm-15.6-41.2c-.8 0-1.5.9-1.5 2s.7 2 1.5 2h12.6c.8 0 1.5-.9 1.5-2s-.7-2-1.5-2h-12.6zm31.3 7.5c-.9 0-1.6.9-1.6 2s.7 2 1.6 2h22.2c.9 0 1.6-.9 1.6-2s-.7-2-1.6-2h-22.2zm-31.3 3.3c-.8 0-1.5.9-1.5 2s.7 2 1.5 2h12.6c.8 0 1.5-.9 1.5-2s-.7-2-1.5-2h-12.6zm0 10.7c-.8 0-1.5.9-1.5 2s.7 2 1.5 2h12.6c.8 0 1.5-.9 1.5-2s-.7-2-1.5-2h-12.6zm0 10.8c-.8 0-1.5.9-1.5 2s.7 2 1.5 2h12.6c.8 0 1.5-.9 1.5-2s-.7-2-1.5-2h-12.6z"
        id="BBicons_BM-Analyza_odvetvi_svg__Analyza_odvetvi"
      />
      <circle
        className="BBicons_BM-Analyza_odvetvi_svg__st4"
        cx={320}
        cy={100}
        r={126.4}
      />
    </g>
  </svg>
);

export default SvgBBiconsBmAnalyzaOdvetvi;
